<template>
    <div class="pa-2"
        style="font-size: 16px !important; font-family: 'DB Helvethaica X Latin', 'Sarabun', sans-serif !important;">

        <v-sheet class="pa-4" color="grey lighten-4">
            <v-toolbar style="background-color: transparent !important;" flat dense>
                <p style="font-size: 20px;" class="mt-0 mb-0 font-weight-bold">Detail</p>
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialogCom">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card v-if="Object.keys(selectedLecture).length != 0" class="mx-auto" outlined
                style="background-color: transparent !important;border-color: transparent !important;">

                <!-- <pre>{{ selectedLecture }}</pre> -->
                <v-list-item three-line>
                    <v-list-item-content>
                        <div class="text-overline mb-2">
                            {{ selectedLecture.id }}
                        </div>
                        <v-list-item-title class="text-h5 mt-0 mb-1">
                            {{ `${selectedLecture.title.short_eng} ${selectedLecture.name} ${selectedLecture.surname}`
                            }}
                        </v-list-item-title>
                        <v-list-item-subtitle>{{ selectedLecture.department.name_eng }}</v-list-item-subtitle>
                        <v-list-item-subtitle class="mt-3"> updated_at :: {{ selectedLecture.updated_at
                            }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar tile rounded size="100">
                        <img :src="'https://my.muic.io/api' +
                            selectedLecture.img
                            " />
                    </v-list-item-avatar>
                </v-list-item>
                <v-card-actions></v-card-actions>
            </v-card>

        </v-sheet>

        <div class="mt-2 mb-5">
            <v-card-text class="mt-5">

                <v-row align="center">
                    <v-col md="4">
                        <v-autocomplete :items="years" v-model="selectYear" label="เลือกดูตามรอบ PA (1 ก.ค. – 30 มิ.ย.)"
                            dense filled hide-details />
                    </v-col>
                    <v-col md="4">
                        <v-btn block class="white--text" height="40" :loading="loadingExcle"
                            :disabled="activityLecture.length === 0 || loadingExcle" color="green"
                            @click="loader = 'loadingExcle'">
                            <v-icon dark class="mr-2">
                                mdi-table-arrow-down
                            </v-icon> Excel report
                            <template v-slot:loader>
                                <span class="custom-loader">
                                    <v-icon light>mdi-cached</v-icon>
                                </span>
                            </template>
                        </v-btn>
                    </v-col>
                </v-row>

                <small class="d-block text-small mt-5 mb-0 text--primary">The summary
                    <v-chip filter dense small color="green" label class="white--text">Approved</v-chip>
                    by the authorized personnel.</small>

                <div class="mt-5 mb-0" style="border-radius: 5px;">
                    <v-row align="center" no-gutters>
                        <v-col v-for="n in dataReportView" :key="'sum-' + n.labelView">
                            <v-card class="pa-2" outlined tile color="grey lighten-4">
                                <div class="text-center">
                                    <h4 class="mt-2 mb-0">{{ n.SumView }} {{ n.labelView }}</h4>
                                    <p style="font-size: 8px;" class="disabled--text mt-0 mb-0">{{ n.remarkView }}
                                    </p>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>

            <v-card-text>

                <hr class="mt-5 mb-5"><br>

                <div v-if="activityLecture.length != 0">
                    <small style="font-size: 18px;" class="text-small mt-0 mb-0 font-weiht-bold text--primary">แบ่งตาม
                        Activity
                        Type</small>
                    <br><br>

                    <v-expansion-panels class="mt-0 mb-5" focusable>
                        <v-expansion-panel v-for="(item, i) in activityType" :key="i">
                            <v-expansion-panel-header>
                                <div>
                                    <p class="mt-0 mb-0 font-weight-bold">{{ item.detail }} ({{ item.point }})</p>
                                    <small>จำนวน {{ groupedActivities[item.id].length }} กิจกรรม</small>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div v-if="groupedActivities[item.id].length === 0">
                                    <p class="mb-3 mt-5 pa-3 grey--text">ยังไม่มีกิจกรรมในหัวข้อนี้</p>
                                </div>

                                <v-card v-for="act in groupedActivities[item.id]" :key="act.id" class="mb-3 mt-5 pa-3"
                                    outlined>
                                    <div class="font-weight-bold mb-1">
                                        {{ act.name_academic }}
                                    </div>

                                    <div>
                                        วันที่: {{ formatDateThai(act.date_start) }} - <span
                                            class="yellow lighten-3 px-1 rounded">{{ formatDateThai(act.date_end)
                                            }}</span>
                                    </div>

                                    <div>
                                        ชม.: {{ act.point_activity }}
                                    </div>

                                    <div>
                                        คะแนนกิจกรรม: {{ act.point_activity }}
                                    </div>

                                    <div v-if="act.files.length">
                                        <a :href="act.files[0].file" target="_blank">
                                            📄 ไฟล์แนบ
                                        </a>
                                    </div>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </div>

                <div v-else class="text-center pa-5 mt-3 mb-5" style="border: 1px dashed #ccc; border-radius: 8px;">
                    <v-icon large color="grey lighten-1" class="mb-2">mdi-clipboard-text-off-outline</v-icon>
                    <p class="grey--text text--darken-1 mb-0" style="font-size: 16px;">ยังไม่พบข้อมูลการส่ง activity</p>
                </div>

                <br>
                <div class="mt-5 mb-2">

                    <small style="font-size: 18px;" class="text-small mt-0 mb-0 text--primary">The summary
                        <v-chip filter dense small color="red" label class="white--text">Reject</v-chip>
                        <v-chip filter dense small color="blue" label class="white--text ml-3">Sent</v-chip>
                        <v-chip filter dense small color="blue" label class="white--text ml-3">Save</v-chip>
                        by the authorized personnel.</small>

                    <v-data-table dense class="mt-3 table-bordered" :headers="headers" :items="dataReportErrorUser">
                        <template v-slot:item.status="{ item }">
                            <v-chip :color="getStatusColor(item.status)" small dark label
                                class="text-capitalize font-weight-bold">
                                {{ item.status === 'send' ? `Sent` : item.status }}
                            </v-chip>
                        </template>
                        <template v-slot:item.name_academic="{ item }">

                            <div class="text-left">
                                <p style="font-weight: 800;font-size: 14px;" class="mt-2 mb-2">
                                <pre>{{ item.name_academic }}</pre>
                                </p>
                                <div><span>Start:</span>&nbsp;&nbsp;{{ formatDateThai(item.date_start) }}</div>
                                <div class="mb-2"><span>End:</span>&nbsp;&nbsp;<span
                                        class="yellow lighten-3 px-1 rounded">{{ formatDateThai(item.date_end) }}</span>
                                </div>
                                <div v-if="item.files && item.files.length > 0" class="mb-2">
                                    <v-chip v-for="(f, idx) in item.files" :key="idx" :href="f.file" target="_blank"
                                        color="primary" small outlined class="mr-1 mb-1" style="cursor: pointer;">
                                        <v-icon left small>mdi-file-document-outline</v-icon>
                                        File {{ idx + 1 }}
                                    </v-chip>
                                </div>
                                <!-- <div class="mb-2"><span>Year:</span>&nbsp;&nbsp;{{ item.year_academic }}</div> -->
                            </div>

                        </template>
                        <template v-slot:item.history="{ item }">
                            <v-list-item three-line>
                                <v-list-item-content>
                                    <v-list-item-title>Verified by</v-list-item-title>
                                    <v-list-item-subtitle>
                                        user :: {{ item.check_academic_by }}
                                    </v-list-item-subtitle>
                                    <v-list-item-subtitle>
                                        <p class="mt-0 mb-0">Update at : {{ item.updated_at }}</p>
                                        <p class="mt-0 mb-0">Create at : {{ item.created_at }}</p>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-btn icon color="error" @click="deleteActivity(item)">
                                <v-icon>mdi-delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>

                </div>

            </v-card-text>
            <div class="mt-2 mb-2 text-center"></div>
        </div>

        <v-dialog v-model="deleteDialog" persistent max-width="400">
            <v-card>
                <v-card-title class="grey lighten-2">
                    <h4 class="font-weight-bold mb-5">Confirm Deletion</h4>
                </v-card-title>
                <v-card-text class="text-center mt-3" style="font-size: 16px;">
                    Are you sure you want to delete this activity? <br>
                    <strong class="red--text">{{ itemToDelete ? itemToDelete.name_academic : '' }}</strong>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="deleteDialog = false">
                        Cancel
                    </v-btn>
                    <v-btn class="text-capitalize white--text font-weight-bold" color="red darken-3" depressed
                        @click="confirmDeleteActivity">
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar.show" :color="snackbar.color" top>
            {{ snackbar.message }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar.show = false">
                    Close
                </v-btn>
            </template>
        </v-snackbar>

    </div>
</template>

<script>
import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'

export default {
    name: 'SheetLecture',
    props: {
        selectedLecture: {
            type: Object,
            default: () => ({}),
        },
        activityLecture: {
            type: Array,
            default: () => ([]),
        },
        dataReportErrorUser: {
            type: Array,
            default: () => ([]),
        },
        // 
        totalHour: {
            type: Number,
            default: () => (0),
        },
        totalPoint: {
            type: Number,
            default: () => (0),
        },
        totalSuccess: {
            type: Number,
            default: () => (0),
        },
        // 
        activityType: {
            type: Array,
            default: () => ([]),
        },
    },
    data: () => ({
        deleteDialog: false,
        itemToDelete: null,
        snackbar: {
            show: false,
            message: '',
            color: ''
        },

        years: [],
        selectYear: null,

        dataReportView: [
            {
                labelView: 'Activities',
                SumView: 0,
                Icon: '',
                remarkView: 'All Activities',
            },
            {
                labelView: 'Hours',
                SumView: 0,
                Icon: '',
                remarkView: 'Total Hours',
            },
            {
                labelView: 'Point',
                SumView: 0,
                Icon: '',
                remarkView: 'Total 1000 Points (Max.)',
            },
        ],
        headers: [
            {
                sortable: false,
                text: "Title",
                value: "name_academic",
                align: "start",
                class: "font-weight-bold  blue-grey darken-3 white--text",
            },
            {
                sortable: false,
                text: "Type",
                value: "activity_type_detail.detail",
                align: "start",
                class: "font-weight-bold  blue-grey darken-3 white--text",
            },
            {
                sortable: false,
                text: "Hours",
                value: "point_activity",
                align: "end",
                class: "font-weight-bold  blue-grey darken-3 white--text",
            },
            {
                sortable: false,
                text: "Status",
                value: "status",
                align: "center",
                class: "font-weight-bold  blue-grey darken-3 white--text",
            },
            {
                sortable: false,
                text: "Actions",
                value: "actions",
                align: "center",
                class: "font-weight-bold  blue-grey darken-3 white--text",
            },
        ],

        // 
        loader: null,
        loadingExcle: false,
    }),

    watch: {
        totalHour() {
            this.updateReportView();
        },
        totalPoint() {
            this.updateReportView();
        },
        totalSuccess() {
            this.updateReportView();
        },
        loader() {
            if (this.loader === 'loadingExcle') {
                this.downloadExcel()
            }
            this.loader = null
        },
        selectYear(val) {
            this.getAdminActivityList(val)
        },
    },

    created() { },

    computed: {
        groupedActivities() {
            const groups = {}

            this.activityType.forEach(type => {
                groups[type.id] = []
            })

            this.activityLecture.forEach(act => {
                const typeId = act.activity_type_detail.id
                if (groups[typeId]) {
                    groups[typeId].push(act)
                }
            })

            return groups
        }
    },


    mounted() {
        this.getPeriods()
    },

    methods: {
        deleteActivity(item) {
            this.itemToDelete = item;
            this.deleteDialog = true;
        },
        showSnackbar(message, color) {
            this.snackbar.message = message;
            this.snackbar.color = color;
            this.snackbar.show = true;
        },
        async confirmDeleteActivity() {
            if (!this.itemToDelete) return;
            const item = this.itemToDelete;
            this.deleteDialog = false;

            if (item.files && item.files.length !== 0) {
                for (let f = 0; f < item.files.length; f++) {
                    const element = item.files[f];
                    try {
                        const resdelFile = await this.$http.delete(
                            `/academic-service/main-activities/${item.id}/files/${element.id}/`
                        );
                        if (![200, 201, 204, "200", "201", "204"].includes(resdelFile.status)) {
                            throw { resdelFile };
                        }
                    } catch (error) {
                        console.log("Failed to delete file:", error);
                    }
                    
                    if (f === parseInt(item.files.length) - 1) {
                        try {
                            const resdel = await this.$http.delete(
                                `/academic-service/main-activities/${item.id}/`
                            );
                            if ([200, 201, 204, "200", "201", "204"].includes(resdel.status)) {
                                const index = this.dataReportErrorUser.findIndex(i => i.id === item.id);
                                if (index !== -1) {
                                    this.dataReportErrorUser.splice(index, 1);
                                }
                                this.showSnackbar("Activity deleted successfully", "success");
                            } else {
                                throw { resdel };
                            }
                        } catch (error) {
                            console.log("Failed to delete activity:", error);
                            this.showSnackbar("Failed to delete activity", "error");
                        }
                    }
                }
            } else {
                try {
                    const resdel = await this.$http.delete(
                        `/academic-service/main-activities/${item.id}/`
                    );
                    if ([200, 201, 204, "200", "201", "204"].includes(resdel.status)) {
                        const index = this.dataReportErrorUser.findIndex(i => i.id === item.id);
                        if (index !== -1) {
                            this.dataReportErrorUser.splice(index, 1);
                        }
                        this.showSnackbar("Activity deleted successfully", "success");
                    } else {
                        throw { resdel };
                    }
                } catch (error) {
                    console.log("Failed to delete activity:", error);
                    this.showSnackbar("Failed to delete activity", "error");
                }
            }
            this.itemToDelete = null;
        },
        updateReportView() {
            this.dataReportView = [
                {
                    labelView: "Activities",
                    SumView: this.totalSuccess,
                    Icon: "",
                    remarkView: 'All Activities',
                },
                {
                    labelView: "Hours",
                    SumView: this.totalHour,
                    Icon: "",
                    remarkView: 'Total Hours',
                },
                {
                    labelView: "Point",
                    SumView: this.totalPoint,
                    Icon: "",
                    remarkView: 'Total 1000 Points (Max.)',
                },
            ];
        },
        getPaDateRange(paYearBE) {
            const yearAD = paYearBE - 543
            return {
                start: this.$dayjs(`${yearAD - 1}-07-01`),
                end: this.$dayjs(`${yearAD}-06-30`)
            }
        },
        async getPeriods() {
            this.years = [
                { value: null, text: 'ทั้งหมด' }
            ]
            const currentBE = new Date().getFullYear() + 543
            // Show 2 years ahead + current year + last 5 years
            for (let i = -2; i <= 5; i++) {
                const year = currentBE - i
                this.years.push({
                    value: year,
                    text: `PA ${year}`
                })
            }
            this.selectYear = currentBE
        },
        formatDateThai(date) {
            if (!date) return '-';
            const d = new Date(date);
            return d.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        },
        getAdminActivityList(val) {
            this.$emit('getActivityListYear', val)
        },
        closeDialogCom() {
            this.$emit('closeDialogCom')
        },
        getStatusColor(status) {
            if (status === 'approve') return 'green';
            if (status === 'reject') return 'red';
            if (status === 'send') return 'blue';
            if (status === 'save') return 'blue'; // Matches the summary key
            return 'grey';
        },
        /**
         * Format activity type label.
         * If type is "Others" and activity_other has a valid value, append it.
         */
        getActivityTypeLabel(item) {
            const typeDetail = item.activity_type_detail ? item.activity_type_detail.detail : '-'
            const activityOther = item.activity_other

            if (typeDetail === 'Others' && activityOther && activityOther !== 'null' && String(activityOther).trim() !== '') {
                return `Others :: ${activityOther}`
            }

            return typeDetail
        },

        /**
         * Format date to DD/MM/YYYY using dayjs.
         */
        formatDateExcel(date) {
            if (!date) {
                return '-'
            }
            return this.$dayjs(date).format('DD/MM/YYYY')
        },

        /**
         * Download approved activities as an Excel report.
         */
        async downloadExcel() {
            this.loadingExcle = true
            try {
                // Get lecturer info
                const lecturer = this.selectedLecture
                const lecturerName = `${lecturer.name || ''} ${lecturer.surname || ''}`.trim()
                const division = lecturer.department ? lecturer.department.name_eng : '-'

                // Filter only approved activities
                const approvedActivities = this.activityLecture
                    .filter(act => act.status === 'approve')
                    .sort((a, b) => new Date(a.date_start) - new Date(b.date_start))

                // Build row data with sequential numbering
                const data = approvedActivities.map((item, index) => ({
                    'No.': index + 1,
                    'Activity Name': item.name_academic || '-',
                    'Activity Type': this.getActivityTypeLabel(item),
                    'Date Start': this.formatDateExcel(item.date_start),
                    'Date End': this.formatDateExcel(item.date_end),
                    'Hours': parseFloat(item.point_activity) || 0,
                    'Points': parseFloat(item.point_activity) || 0,
                }))

                // Calculate totals
                const totalActivities = approvedActivities.length
                const totalHours = approvedActivities.reduce((sum, act) => sum + (parseFloat(act.point_activity) || 0), 0)
                const totalPoints = approvedActivities.reduce((sum, act) => sum + (parseFloat(act.point_activity) || 0), 0)

                // Create worksheet
                const worksheet = XLSX.utils.json_to_sheet([])

                // Row 1: Report title (merged A1:G1)
                const headerTitle = `Report Instructor ${lecturerName} PA${this.selectYear}`
                XLSX.utils.sheet_add_aoa(worksheet, [[headerTitle]], { origin: 'A1' })

                // Row 2: Division info (merged A2:G2)
                XLSX.utils.sheet_add_aoa(worksheet, [[`Division: ${division}`]], { origin: 'A2' })

                // Define merged cell ranges
                worksheet['!merges'] = [
                    { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },
                    { s: { r: 1, c: 0 }, e: { r: 1, c: 6 } },
                ]

                // Row 3: Column headers
                const headers = ['No.', 'Activity Name', 'Activity Type', 'Date Start', 'Date End', 'Hours', 'Points']
                XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A3' })

                // Row 4+: Activity data
                XLSX.utils.sheet_add_json(worksheet, data, { origin: 'A4', skipHeader: true })

                // Summary row after data
                const summaryRowIndex = 4 + data.length
                XLSX.utils.sheet_add_aoa(worksheet, [
                    ['Total Activities', totalActivities, '', '', 'Total Hours', totalHours, totalPoints]
                ], { origin: `A${summaryRowIndex + 1}` })

                // Set column widths
                worksheet['!cols'] = [
                    { wch: 5 },   // No.
                    { wch: 40 },  // Activity Name
                    { wch: 35 },  // Activity Type
                    { wch: 15 },  // Date Start
                    { wch: 15 },  // Date End
                    { wch: 12 },  // Hours
                    { wch: 12 },  // Points
                ]

                // Create workbook and export
                const workbook = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Report')

                const safeName = lecturerName.replace(/\s+/g, '_')
                const fileName = `Report_Instructor_${safeName}_PA${this.selectYear}.xlsx`

                const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
                const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                saveAs(blob, fileName)
            } catch (error) {
                console.error('Error downloading Excel:', error)
            } finally {
                this.loadingExcle = false
            }
        }
    }

}
</script>
